
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 16.5 15.7","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"st0",attrs:{"d":"M10.9 4.1v1.5L12 4.5v-.4c0-.7-.6-1.2-1.2-1.2h-1V4h1c.1 0 .1.1.1.1zM11.3 13.1l-.3.1v1.2c0 .1-.1.1-.1.1H1.2c-.1 0-.1-.1-.1-.1V4.1l.1-.1h1V2.9h-1C.6 2.9 0 3.5 0 4.1v10.4c0 .7.6 1.2 1.2 1.2h9.6c.7 0 1.2-.5 1.2-1.2v-2.1l-.7.7z"}}),_c('path',{staticClass:"st0",attrs:{"d":"M7.7 5.9H4.3c-.6 0-1.2-.5-1.2-1.2V2.8c0-.4.2-.8.5-1C3.9.7 4.8 0 6 0c1.3 0 2.1.7 2.3 1.8.3.2.5.6.5 1v1.9c.1.7-.4 1.2-1.1 1.2zM6 1.1c-.8 0-1.2.4-1.3 1.1v.4l-.4.1s-.1 0-.1.1v1.9s0 .1.1.1h3.4s.1 0 .1-.1V2.8s0-.1-.1-.1h-.4v-.4c0-.8-.5-1.2-1.3-1.2z"}}),_c('g',[_c('path',{staticClass:"st0",attrs:{"d":"M9 7.6H2.9v1H8zM7.2 9.9H2.9V11h3.9z"}})]),_c('path',{staticClass:"st0",attrs:{"d":"M16.2 5.2l-.9-.9c-.2-.2-.5-.4-.9-.4-.5 0-.8.3-1 .6L8.6 9.3l-1.4 3.6c0 .1.1.2.2.2l3.7-1.3L16 6.9c.3-.3.8-.9.2-1.7zm-5.3 5.3l-.9-1 3-3.1 1 1-3.1 3.1zm-1.9.9l.3-.9.6.5-.9.4zM14.4 5s.1 0 .1.1l.8.8-.2.2-.4.4-1-1 .7-.5z"}}),_c('g',[_c('circle',{staticClass:"st0",attrs:{"cx":"6","cy":"2.3","r":".7"}})])])
          )
        }
      }
    